import { Component, Input } from '@angular/core';
import { IsNotMidnightPipe } from '../../../../../pipes/is-not-midnight.pipe';
import { DatePipe } from '@angular/common';
import { FormatRouteLocationPipe } from '../../../pipes/format-route-location.pipe';
import { ShouldShowConfirmedRoutingPipe } from '../../../pipes/should-show-confirmed-routing.pipe';
import { timeFormat } from '../../../../../models/date-formats';
import { ShipmentRoute } from '../../../../../pages/overview/models/shipment';

@Component({
  selector: 'app-routing-confirmed',
  standalone: true,
  templateUrl: './routing-confirmed.component.html',
  imports: [IsNotMidnightPipe, DatePipe, FormatRouteLocationPipe, ShouldShowConfirmedRoutingPipe],
  styleUrl: './routing-confirmed.component.scss'
})
export class RoutingConfirmedComponent {
  @Input() routes: ShipmentRoute[] | null = null;
  readonly timeFormat = timeFormat;
}
